import { render, staticRenderFns } from "./TableChannels.vue?vue&type=template&id=fc017f92"
import script from "./TableChannels.vue?vue&type=script&lang=js"
export * from "./TableChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports